
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { Observable } from "rxjs";
import { MAIL_FIELD_KEYS, MailTemplate, REPORT_PDF_OPTIONEN } from "../../../../_models/mail-template.interface";
import { FullProjectHash } from "../../../../_models/project.interface";
import { ProjectService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";

@Component({
  selector: "hawk-edit-mail-template",
  imports: [FormsModule, ReactiveFormsModule],
  templateUrl: "./edit-mail-template.component.html",
  standalone: true,
  styleUrls: ["edit-mail-template.component.scss"],
})
export class EditMailTemplateComponent extends FormModalComponent<MailTemplate, FullProjectHash> {
  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  protected readonly reportPdfOptionen = REPORT_PDF_OPTIONEN;

  constructor(private projectService: ProjectService) {
    super();
  }

  override formGroupToDBInput(): MailTemplate {
    return {
      id: this.formGroup.controls["id"].value,
      project_id: this.formGroup.controls["project_id"].value,
      subject: this.formGroup.controls["subject"].value,
      text: this.formGroup.controls["text"].value,
      type: this.formGroup.controls["type"].value,
      report_pdf: this.formGroup.controls["report_pdf"]?.value || "none",
      mail_fields: MAIL_FIELD_KEYS
        .filter((field) => this.formGroup.controls[field] && this.formGroup.controls[field].value)
        .map((field) => ({ name: field }))
    }
  }

  override getDBCallObservable(create_mail_template_attributes: MailTemplate): Observable<FullProjectHash> {
    return this.projectService.updateProjectMailTemplate(
      create_mail_template_attributes.project_id,
      create_mail_template_attributes.id,
      create_mail_template_attributes
    );
  }
}
